//Core
import React, { useEffect } from "react"

//Components
import InputSimple from "../../../../components/InputSimple"

//UI
import Spinner from "../../../../components/UI/LigthSpinner"
import {
  onSuccessCredit,
  onFail,
  onError,
  onSucces,
} from "../../../../components/UI/PopUp"

//Helpers
import { classes } from "../../../../helpers/classname"

//Hooks
import useForm from "../../../../FormHooks/creditHook"

//Style
import style from "./style.module.scss"

const { Container, FormWrapper, ButtonWrapper, Button } = style

const CreditForm = ({ link }) => {
  const {
    state,
    checkedInn,
    changeInn,

    checkedPhone,
    changePhone,
    sendUserOrder,
    onClick,
  } = useForm(link)
  const { phone, fetch, inn, success, fail, error, sendOrderSuccess } = state

  return fetch ? (
    <Spinner color={`#273592`} />
  ) : (
    <>
      <div id="form" className={classes(Container)}>
        <form
          className={classes(FormWrapper)}
          onSubmit={e => {
            e.preventDefault()
            onClick()
          }}
        >
          <InputSimple
            change={changeInn}
            message={"Перевірте правильність вводу ІПН"}
            checked={inn.checked}
            placeholder={"Індивідуальний податковий номер"}
            valid={inn.valid}
            type="number"
            chakedFunc={checkedInn}
            full={true}
          ></InputSimple>
          <InputSimple
            full={true}
            change={changePhone}
            change={changePhone}
            chakedFunc={checkedPhone}
            checked={phone.checked}
            valid={phone.valid}
            message={"Перевірте правильність вводу номера мобільного телефону"}
            placeholder={"Фінансовий номер телефона"}
            type="phone"
          ></InputSimple>
        </form>
        <div className={ButtonWrapper}>
          <button className={Button} onClick={onClick}>
            ПРИЄДНАТИСЯ ДО КАНІКУЛ
          </button>
        </div>
      </div>

      {success ? onSuccessCredit(sendUserOrder) : null}
      {fail ? onFail() : null}
      {error ? onError() : null}
      {sendOrderSuccess ? onSucces(`Ваша заявка прийнята!`) : null}
    </>
  )
}

export default CreditForm
